// ---------------------------------------------------------------------------
// VerificationStatusBadge — tiny badge showing PASS/FAIL/NOT_RUN status.
// ---------------------------------------------------------------------------

interface Props {
  status: 'pass' | 'fail' | 'not_run'
}

const STATUS_CONFIG = {
  pass: { icon: '●', color: 'text-success', label: 'Verified' },
  fail: { icon: '✗', color: 'text-red-500', label: 'Failed' },
  not_run: { icon: '○', color: 'text-gray-400', label: 'Not verified' },
} as const

export function VerificationStatusBadge({ status }: Props) {
  const config = STATUS_CONFIG[status]

  return (
    // RUX-09: the glyph is color-only and the label lived solely in title=,
    // which screen readers skip — role="status" + aria-label make the badge
    // announce its state ("Flow verification: Verified").
    <span
      role="status"
      aria-label={`Flow verification: ${config.label}`}
      className={`inline-flex items-center gap-1 text-xs ${config.color}`}
      title={config.label}
    >
      {config.icon}
    </span>
  )
}
